export const fmtPrice = (n) => (Number.isInteger(n) ? `${n}` : n.toFixed(2));

export const BRAND = {
  name: "Tap 4 Reviews",
  logoFirst: "TAP",
  logoAccent: "4",
  logoSecond: "REVIEWS",
  logoUrl: "/logo-mark.png",
  badge: "Trusted by students across Australia & worldwide",
  heroSubtitle: "Learn How I Get Paid By Generating Businesses Organic Leads",
  ctaPrimary: "Get the Method",
  ctaSecondary: "See real results",
};

export const PRODUCTS = [
  {
    id: "supplier",
    kicker: null,
    name: "Google Review NFC Card Supplier",
    description: "Private supplier link. Low-cost cards. No order minimum.",
    price: 18,
    currency: "A$",
    note: "One-time · Delivered to your inbox instantly",
    image:
      "https://static.prod-images.emergentagent.com/jobs/eea60ab7-505c-4f1a-885d-efb1c1ab643f/images/86c0a5fb53cc553c9fc728706cd331573488b4c808b628e69e9bc2a561a0eef7.png",
    popular: false,
  },
    {
    id: "guide",
    kicker: "Most Popular",
    name: "Google Review Card Guide",
    description:
      "Step-by-step PDF: how to set up the card and how to get your first sale. Supplier included.",
    price: 34,
    currency: "A$",
    note: "One-time · Delivered to your inbox instantly",
    image:
      "https://static.prod-images.emergentagent.com/jobs/eea60ab7-505c-4f1a-885d-efb1c1ab643f/images/b297e78ffa1f6a9539f5f799ff779bc816484d508bda638d0993c57fe4d91a33.png",
    popular: true,
  },
  {
    id: "bundle",
    kicker: "Best Value",
    name: "Complete Bundle",
    description:
      "Supplier access + the full Card Guide together. Everything you need to make your first sale this week.",
    price: 49,
    originalPrice: 52,
    currency: "A$",
    note: "One-time · Both PDFs delivered to your inbox instantly",
    image:
      "https://static.prod-images.emergentagent.com/jobs/eea60ab7-505c-4f1a-885d-efb1c1ab643f/images/cff750b70534b8341bfc8109decc06c5a7d478243ea355aa73765f4caf0b6a42.png",
    popular: true,
  },
];

export const STEPS = [
  {
    number: "01",
    title: "Order NFC cards from the supplier",
    description:
      "Use the exact supplier list inside the guide. Cards arrive ready to program. No design work, no waiting weeks.",
  },
  {
    number: "02",
    title: "Walk into local businesses",
    description:
      "Restaurants, barbershops, nail salons, cafes. Anywhere that depends on Google reviews. Show them the card. Done.",
  },
  {
    number: "03",
    title: "Close on the spot for $50 to $100 per card",
    description:
      "Use the scripts inside the guide. Most owners say yes in under 5 minutes because the ROI is obvious.",
  },
  {
    number: "04",
    title: "Repeat. Scale. Stack offers.",
    description:
      "Once you have a customer, upsell signage, batches, and the full Google Business optimization service. Recurring revenue.",
  },
];

export const PROOF_IMAGES = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_silly-merkle-6/artifacts/1rzi8w5k_Image%2014-7-2026%20at%203.43%20pm.jpeg",
    alt: "Student result",
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_silly-merkle-6/artifacts/7cnx9pqy_Image%2014-7-2026%20at%203.43%20pm%20%281%29.jpeg",
    alt: "Student result",
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_silly-merkle-6/artifacts/zak727ey_Image%2014-7-2026%20at%203.44%20pm.jpeg",
    alt: "Student result",
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_silly-merkle-6/artifacts/or71nzvf_Image%2014-7-2026%20at%203.44%20pm%20%281%29.jpeg",
    alt: "Student result",
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_silly-merkle-6/artifacts/uofy9qrn_Image%2014-7-2026%20at%203.44%20pm%20%282%29.jpeg",
    alt: "Student result",
  },
];

export const FAQS = [
  {
    question: "Do I need followers or any social media to make this work?",
    answer:
      "No. The entire method is built around walking into local businesses or sending cold DMs/emails. The guide includes scripts for both. Most students get their first sale before they ever post online.",
  },
  {
    question: "How much does it cost to get started?",
    answer:
      "The guide is a one-time payment, and the cards themselves are cheap to order from the supplier. Most students start with 10-20 cards and are fully up and running for a small upfront cost.",
  },
  {
    question: "What's the difference between the two products?",
    answer:
      "The supplier package gives you the private supplier link only. The Google Review Card Guide includes everything: the supplier, step-by-step training, sales scripts, pricing strategy, and the full scaling playbook.",
  },
  {
    question: "When do I get access after buying?",
    answer:
      "Instantly. As soon as your payment goes through, the PDF is automatically sent to the email you enter at checkout. No waiting, no approval process.",
  },
  {
    question: "What if it doesn't work for me?",
    answer:
      "The method is simple, but it does require you to take action. If you follow the steps, show the card to enough business owners, and use the scripts, the results follow. Support is available if you get stuck.",
  },
  {
    question: "Does this work outside Australia?",
    answer:
      "Yes. Anywhere businesses rely on Google reviews, this works. The supplier ships internationally and the scripts translate to any market.",
  },
];
